import {assertAndContinue} from 'Asserts';
import {Cells, RowDataUiData} from 'notebook/tables/constants/RowConstants';
import {EvaluatedCell} from 'notebook/tables/excess/EvaluationConstants';
import {formatTypedValue, formatTypedValueWithIds} from 'notebook/tables/typed-values/DataTypes';

import {getHeaderRow, maybeAddValueModifier} from './GetPlainTextTableUtil';

/**
 * @param includeCellValueModifiers  If true, cell values in the plain text representation may
 *                                   include additional information (useful for exports)
 */
export default function getPlainTextTable({
  table,
  computedTable,
  includeCellValueModifiers,
  headerRow,
  rowLabels,
  rowLabelHeader,
  rowUiData,
  inaccessibleIds,
  useIds,
}: {
  table: Cells;
  computedTable: Array<Array<EvaluatedCell>>;
  includeCellValueModifiers: boolean;
  headerRow?: Array<string> | null;
  rowLabels?: Array<string> | null;
  rowLabelHeader?: string | null;
  rowUiData?: Array<RowDataUiData>;
  inaccessibleIds?: Set<string>;
  useIds?: boolean;
}): Array<Array<string>> {
  const formatFunction = useIds ? formatTypedValueWithIds : formatTypedValue;
  if (rowLabels == null) {
    assertAndContinue(rowLabelHeader == null, `Row label header cannot be specified without row labels`, {
      rowLabels,
      rowLabelHeader,
    });
  }

  const exportedRows: Array<Array<string>> = [];
  if (headerRow) {
    exportedRows.push(getHeaderRow(headerRow, rowLabels, rowLabelHeader, rowUiData));
  }
  for (let i = 0; i < computedTable.length; i++) {
    const exportedRow: Array<string> = [];
    if (rowLabels != null) {
      exportedRow.push(rowLabels[i]);
    }
    for (let j = 0; j < computedTable[i].length; j++) {
      const evaluatedCell = computedTable[i][j];
      const cell = table[i][j];
      let value = formatFunction(evaluatedCell.value, cell, ', ', inaccessibleIds);
      if (includeCellValueModifiers) {
        value = maybeAddValueModifier(value, cell, evaluatedCell);
      }
      exportedRow.push(value);
    }

    if (rowUiData != null) {
      exportedRow.push(rowUiData[i].archivePurpose != null ? 'Yes' : 'No');
      exportedRow.push(rowUiData[i].archivePurpose != null ? rowUiData[i].archivePurpose! : '');
    }

    exportedRows.push(exportedRow);
  }
  return exportedRows;
}
